import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FilterableSettings, DataBindingDirective } from "@progress/kendo-angular-grid";
import { SVGIcon, filePdfIcon, fileExcelIcon } from "@progress/kendo-svg-icons";

import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';

import { createinvildBills, getBillsByIdlist, Paycashbill, resetbillsState } from '../../../store/Bills/bills.action';
import { Router } from '@angular/router';
import { Store, compose, select } from '@ngrx/store';
import { LoaderService } from '../../../core/services/loader.service';

import { SharedService } from '../../../shared/shared.service';


@Component({
  selector: 'app-rp-bills-view',
  templateUrl: './rp-bills-view.component.html',
  styleUrl: './rp-bills-view.component.scss',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .k-grid .k-grid-content td {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `,
  ],
})
export class RpBillsViewComponent {
  billsDataById = Object.assign({});
  isAllOpen: boolean = true;
  modalRef!: BsModalRef;
  modalRefInvoice!: BsModalRef;
  billapidmodal!: BsModalRef;
  reason: any;
  viewBilldeatils = Object.assign({});
  breadCrumbItems: Array<{}> | undefined;

  public paybycashform!: FormGroup;

  public filterMode: FilterableSettings = 'row';
  public filePdfIcon: SVGIcon = filePdfIcon;
  public fileExcelIcon: SVGIcon = fileExcelIcon;
  public mySelection: string[] = [];

  // file upload
  uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
  uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
  manualBillGrid: boolean = true;
  manualBillView: boolean = false;
  adhocBillGrid: boolean = true;
  adhocBillView: boolean = false;
  billPaymentDate: any;
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  undefinde: any;
  currentUser: any;
  projectId: any;
  billingType: any;
  billGenerationDate: any;
  minDate: any;
  today: any;
  constructor(
    private sharedService: SharedService,
    private modalService: BsModalService,
    private fb: FormBuilder,
    private router: Router,
    private store: Store
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    this.projectId = this.currentUser?.project.id;
    this.billGenerationDate = this.currentUser.billGenerationDate;
    this.billingType = this.currentUser.project.billingType;
    if (history.state.bilss != undefined && history.state.bilss !== null) {
      this.billsDataById = history.state.bilss;
      console.log(this.billsDataById);
      this.sharedService.setbilldeatilsById(this.billsDataById);
    }
    console.log(this.billsDataById);
    this.breadCrumbItems = [
      { label: 'Bills', url: 'bills', active: true },
      { label: 'Bills Details' },
    ];

    this.paybycashform = this.fb.group({
      amount: [''],
      billPaymentDate: [null, Validators.required],
      reason: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    console.log(this.billGenerationDate);
    this.today = new Date().toISOString().split('T')[0];
    console.log(this.billingType);
    this.minDate =
      this.billingType == 'Postpaid'
        ? this.formatDate(this.billGenerationDate)
        : this.today;
  }

  formatDate(isoString: any) {
    const date = new Date(isoString);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }
  buttondisabled: boolean = true;
  billPaymentDateChange(event: any) {
    const dt = this.paybycashform.get('billPaymentDate')?.value;
    console.log(dt);
    console.log(event);
    if (dt) {
      this.buttondisabled = false;
    }
  }

  get paybycashControls() {
    return this.paybycashform.controls;
  }
  payByCash() {
    console.log(this.paybycashform.invalid);
    if (this.paybycashform.invalid) {
      return;
    } else {
      let request = {
        billId: this.billsDataById.id,
        amount: this.paybycashform.get('amount')?.value,
        paidDate: this.paybycashform.get('billPaymentDate')?.value,
        reason: this.paybycashform.get('reason')?.value,
      };
      this.store.dispatch(Paycashbill({ bilss: request }));
      this.billapidmodal.hide();
    }
  }
  saveInvlaidBills() {
    /*  this.store.dispatch(
       createinvildBills({ reason: this.reason, id: this.billsDataById.id })
     ); */
    this.modalRefInvoice.hide();
  }
  config: any = {
    backdrop: true,
    ignoreBackdropClick: true,
  };

  //Append Fields Set
  private addElectricityGroup(): FormGroup {
    return this.fb.group({
      slabName: [],
      minKwh: [],
      maxKwh: [],
      slabPerUnitPrice: [],
    });
  }

  /**
   * Open center modal
   * @param invalidBillModal center modal data
   */
  invalidBillsModal(invalidBillModal: any) {
    this.reason = '';
    this.modalRefInvoice = this.modalService.show(invalidBillModal, {
      class: 'modal-dialog-centered',
    });
  }

  markASPaid(paidBillModal: any) {
    this.reason = '';
    this.billapidmodal = this.modalService.show(paidBillModal, {
      class: 'modal-dialog-centered',
    });
  }
}

